export default function IsNegotiable({ searchObject, setSearchObject, t }) {
  function oncheckBoxCheked({ target }) {
    setSearchObject({
      ...searchObject,
      [target.name]: target.checked
    });
  }

  return (
    <div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          name="isNegotiable"
          checked={searchObject.isNegotiable}
          onChange={oncheckBoxCheked}
        />
        <label
          className="form-check-label fontsize-legend"
          for="flexCheckDefault"
        >
          {t("Negotiable?")}
        </label>
      </div>
    </div>
  );
}
